import { render, staticRenderFns } from "./online_aftersale_detail.vue?vue&type=template&id=a432e37e&scoped=true"
import script from "./online_aftersale_detail.vue?vue&type=script&lang=js"
export * from "./online_aftersale_detail.vue?vue&type=script&lang=js"
import style0 from "./online_aftersale_detail.vue?vue&type=style&index=0&id=a432e37e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a432e37e",
  null
  
)

export default component.exports